<script>
import Path from 'path'
import Lib from '@/lib'
import Filesize from '@/components/common/Filesize'
import Percentage from '@/components/common/Percentage'
import ImageTypeBadge from '@/components/common/ImageTypeBadge'

export default {
  components: {
    Filesize,
    Percentage,
    ImageTypeBadge,
  },
  props: {
    s3KeyBase: String,
    resources: Array,
  },
  computed: {
    hasResoruces: function() {
      return this.resources.length > 0
    },
    noResoruces: function() {
      return this.resources.length == 0
    },
    sizes: function() {
      const sizes = this.resources.reduce((sizes, r) => {
        for (let key in r.data) {
          sizes[key] = (sizes[key] || 0);
          sizes[key] += (r.data[key].size || 0);
        }
        return sizes;
      }, {});
      return sizes;
    },
    reduces: function() {
      const sizes = this.sizes;
      const reduces = {};
      for (let key in sizes) {
        reduces[key] = sizes[key] - sizes.orig;
      }
      return reduces;
    },
    reduceRates: function() {
      const sizes = this.sizes;
      const reduces = this.reduces;
      const rates = {};
      for (let key in sizes) {
        rates[key] = reduces[key] / sizes.orig;
      }
      return rates;
    },
    sizesByExt: function() {
      const sizes = this.resources.reduce((sizes, r) => {
        for (let key in r.data) {
          sizes[key] = sizes[key] || {};
          sizes[key][r.ext] = sizes[key][r.ext] || 0;
          sizes[key][r.ext] += (r.data[key].size || 0);
        }
        return sizes;
      }, {});
      return sizes;
    },
    reducesByExt: function() {
      const sizes = this.sizesByExt;
      const reduces = {};
      for (let key in sizes) {
        for (let ext in sizes[key]) {
          reduces[key] = reduces[key] || {};
          reduces[key][ext] = sizes[key][ext] - sizes.orig[ext];
        }
      }
      return reduces;
    },
    reduceRatesByExt: function() {
      const sizes = this.sizesByExt;
      const reduces = this.reducesByExt;
      const rates = {};
      for (let key in sizes) {
        for (let ext in sizes[key]) {
          rates[key] = rates[key] || {};
          rates[key][ext] = reduces[key][ext] / sizes.orig[ext];
        }
      }
      return rates;
    },
    uniqueExts: function() {
      const unique = { jpg: 0, png: 0, gif: 0 };
      this.imageResources.forEach(r => unique[r.ext]++);
      return Object.keys(unique).filter(ext => unique[ext] > 0)
    }
  },
  methods: {
    imageResourceUrl: function(resource, key) {
      const uri = Path.join(resource.s3KeyBase, resource.data[key].s3KeyPath);
      const url = new URL(uri, Lib.preset().resourceUrlBase);
      return url.href;
    },
    resourceReduced: function(resource, key) {
      return resource.data[key].size - resource.data.orig.size;
    },
    resourceReducedRate: function(resource, key) {
      return (resource.data[key].size - resource.data.orig.size) / resource.data.orig.size;
    }
  },

}
</script>